

















































































import Vue from 'vue'
import { Prop, Emit, Component } from 'vue-property-decorator'
import { Case } from '@/modules/Newcase/interfaces/case'
import { translateCaseTypeKey } from '@/utils/translate'
import { caseTypeClass, casePriorityClass, caseStatusToUp, casePhaseObj } from '@/modules/Newcase/helpers/case'
import { CaseType } from '@/modules/Case/interfaces/case'
import { showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'

@Component({})
export default class CaseDashboardCard2 extends Vue {
  @Prop() readonly caseInfo!: Case
  @Prop() readonly caseImpUrgType!: String
  @Prop() readonly index!: Number
  @Prop({ type: Number }) readonly topCaseListLength!: number

  translateCaseTypeKey = translateCaseTypeKey
  casePriorityClass = casePriorityClass
  caseTypeClass = caseTypeClass

  progressList = ['Client & Inquiry', 'Quote & Proposal', 'Binding', 'Review', 'Post Binding']
  activeImp = false
  activeUrg = false

  show = false

  get formsite () {
    const { formsite, producerForm } = this.caseInfo
    if (!formsite && !producerForm) {
      return null
    }

    if (formsite) {
      return JSON.parse(this.caseInfo.formsite)
    } else {
      return JSON.parse(this.caseInfo.producerForm)
    }
  }

  get ifNewProducer () {
    return this.caseInfo.ifNewProducer
  }

  get insuredName () {
    if (!this.formsite) {
      return null
    }

    const insuredInfo = this.formsite.content['Insured Info']
    const name = this.formsite.insuredName
    if (insuredInfo) {
      const insuredName = insuredInfo.find((item: any) => item.key === "Insured's Name")
      return insuredName ? insuredName.value : null
    }
    if (name) {
      return name
    }
  }

  get formsiteName () {
    if (!this.formsite) {
      return null
    }
    const name = this.formsite.name
    if (name === 'Verge Auto / Home Quick Quote') {
      const lineOfProduct = this.formsite.lineOfProduct.toLowerCase()
      if (lineOfProduct === 'home') {
        return 'Verge Home Quick Quote'
      }
      if (lineOfProduct === 'auto') {
        return 'Verge Personal Auto Quick Quote'
      }
    }
    return name
  }

  mounted () {
    this.show = true
  }

  // 置顶
  async onTop () {
    if (this.topCaseListLength >= 10) {
      showNotification({
        msg: '置顶不能超过 10 个！',
        type: SnackType.Error
      })
      return
    }
    this.show = false
    setTimeout(() => {
      this.emitOnTop()
    }, 300)
  }
  // 取消置顶
  async unTop () {
    this.show = false
    setTimeout(() => {
      this.emitUnTop()
    }, 300)
  }

  routeToDetail () {
    let name = 'NewcaseDetail'
    if (this.caseInfo.type !== CaseType.NEW_BUSINESS) {
      name = 'CaseDetailDetail'
    }
    if (this.formsite && !this.caseInfo.account) {
      name = 'CreateFormSiteCase'
    }
    return {
      name,
      params: {
        id: this.caseInfo.id
      }
    }
  }

  @Emit('onTop')
  async emitOnTop () {
    return {
      index: this.index,
      caseImpUrgType: this.caseImpUrgType,
      item: this.caseInfo
    }
  }

  @Emit('unTop')
  async emitUnTop () {
    return {
      index: this.index,
      caseImpUrgType: this.caseImpUrgType,
      item: this.caseInfo
    }
  }

  // 编辑重要性
  @Emit('important-change')
  async handleImp (val:boolean) {
    return {
      item: this.caseInfo,
      caseImpUrgType: this.caseImpUrgType,
      index: this.index
    }
  }
  // 编辑紧急性
  @Emit('urgent-change')
  async handleUrg (val:boolean) {
    return {
      item: this.caseInfo,
      caseImpUrgType: this.caseImpUrgType,
      index: this.index
    }
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  getCaseTypeColor (type: string) {
    const colorObj = {
      color: '',
      bg: ''
    }
    switch (type) {
      case CaseType.BOR:
        colorObj.color = '#DC6C6C'
        colorObj.bg = '#FFDDE3'
        break
      case CaseType.ENDORSEMENT:
        colorObj.color = '#6A5E9C'
        colorObj.bg = '#D2DBF1'
        break
      case CaseType.CANCELLATION:
        colorObj.color = '#5691E3'
        colorObj.bg = '#C3E8FD'
        break
      case CaseType.REMARKET:
        colorObj.color = '#4C9F5B'
        colorObj.bg = '#D0E9DB'
        break
      case CaseType.REWRITE:
        colorObj.color = '#B657E9 '
        colorObj.bg = '#F5E4FE'
        break
      case CaseType.RENEWAL:
        colorObj.color = '#309BFF'
        colorObj.bg = '#D6EBFF '
        break
      case CaseType.NEW_BUSINESS:
        colorObj.color = '#FF7A01'
        colorObj.bg = '#FFF1CD'
        break
    }
    return colorObj
  }

  getProgressValue (step:number) {
    return step / this.progressList.length * 100
  }

  get openedDays () {
    if (!this.caseInfo) {
      return ''
    }

    const { openDate, closeDate, closed } = this.caseInfo

    const closeDateM = this.$moment.unix(closeDate).tz('America/New_York')
    const openDateM = this.$moment.unix(openDate).tz('America/New_York')
    const nowM = this.$moment().tz('America/New_York')

    return closed
      ? closeDateM.diff(openDateM, 'days')
      : nowM.diff(openDateM, 'days')
  }
}
